import { User } from "@/components/users/types";

export interface InferredName {
  first_name: string;
  last_name: string;
}

const EMPTY: InferredName = { first_name: "", last_name: "" };

const hasLetter = (part: string) => /\p{L}/u.test(part);

function titleCase(part: string): string {
  return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
}

// "ada.lovelace+test@example.com" -> { first_name: "Ada", last_name: "Lovelace" }
export function inferNameFromEmail(email?: string): InferredName {
  const localPart = (email ?? "").split("@")[0].split("+")[0];
  const parts = localPart.split(".").filter(hasLetter).map(titleCase);
  if (parts.length === 0) {
    return EMPTY;
  }

  return { first_name: parts[0], last_name: parts.slice(1).join(" ") };
}

// Only a user with neither name set gets a guess: once either field is
// populated the stored value is authoritative and must never be overwritten.
export function inferredNameFor(currentUser?: User): InferredName {
  if (!currentUser || currentUser.first_name || currentUser.last_name) {
    return EMPTY;
  }

  return inferNameFromEmail(currentUser.email);
}
